import { useEffect } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { hideToast } from 'store/Toast/Toast.action';
import { IRootStore } from 'store/Root.reducer';

const AUTO_HIDE_MS = 3000;

const WidgetToast = () => {
  const dispatch = useDispatch();
  const { id, active, message, variant } = useSelector((state: IRootStore) => state.toast);

  useEffect(() => {
    if (!active) return;
    const timer = setTimeout(() => {
      dispatch(hideToast());
    }, AUTO_HIDE_MS);
    return () => clearTimeout(timer);
  }, [id, active, dispatch]);

  return (
    <div
      className={classNames('toast', `toast--${variant}`, { 'toast--active': active })}
      role="status"
      aria-live="polite"
    >
      <div className="toast__body">{message}</div>
    </div>
  );
};

export default WidgetToast;
